var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTabPush = function SvgTabPush(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3.5a9.5 9.5 0 0 1 6.79 16.14l-1.15 1a9.5 9.5 0 0 1-11.28 0l-1.15-1A9.5 9.5 0 0 1 12 3.5m0 2a7.5 7.5 0 0 0-5.57 12.51l.17.18 1 .88.2.15a7.5 7.5 0 0 0 3.88 1.27l.32.01c1.52 0 2.96-.45 4.2-1.28l.2-.15 1-.88.17-.18a7.43 7.43 0 0 0 1.92-4.7l.01-.3A7.5 7.5 0 0 0 12 5.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.52 12.12a1 1 0 0 1 .96 1.76l-4.15 2.24a1 1 0 0 1-.95-1.76zM5.92 1.5a1 1 0 0 1 .94 1.77 11.07 11.07 0 0 0-4.37 4.2A1 1 0 0 1 .77 6.46a13.07 13.07 0 0 1 5.15-4.95Zm12.16 0a1 1 0 0 0-.94 1.77c1.81.97 3.33 2.42 4.37 4.2a1 1 0 0 0 1.72-1.01 13.07 13.07 0 0 0-5.15-4.95Z"
  }))));
};
export default SvgTabPush;